/**
 *
 * @description Fallback.tsx
 * @author yikkok <yikok.yong@gmail.com>
 * @version 1.0.0
 * @since 13 November 2021
 *
 */

import { Empty } from 'antd';
import { ChildrenT } from '~/@customTypes/generic';

type Props = ChildrenT & {
  showEmpty?: boolean | undefined;
};
export default function Fallback({ showEmpty = true, children }: Props) {
  if (showEmpty) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={'Empty'} />;
  }

  return <>{children}</>;
}
